import { colors } from '@mui/material';

/**
 * Get a deterministic color based on the input string
 * @returns 
 */
const getDeterministicColor = (input: string): string => {
    const colorPalette = [
        colors.red[200], colors.pink[200], colors.purple[200], colors.deepPurple[200],
        colors.indigo[200], colors.blue[200], colors.lightBlue[200], colors.cyan[200],
        colors.teal[200], colors.green[200], colors.yellow[200], colors.amber[200],
        colors.orange[200], colors.deepOrange[200], colors.grey[200], colors.blueGrey[200]
    ];

    let hash = 0;
    for (let char of input) {
        hash = char.charCodeAt(0) + ((hash << 5) - hash);
    }

    return colorPalette[Math.abs(hash) % colorPalette.length];
}

export default getDeterministicColor;